__turbopack_context__.v({
  "fieldset": "fieldset-module-scss-module__E1iU-a__fieldset",
  "fieldsetLegend": "fieldset-module-scss-module__E1iU-a__fieldsetLegend",
  "themeGrey": "fieldset-module-scss-module__E1iU-a__themeGrey",
  "themeHidden": "fieldset-module-scss-module__E1iU-a__themeHidden",
  "themeWeb2": "fieldset-module-scss-module__E1iU-a__themeWeb2",
});
